import { render, staticRenderFns } from "./SalarieHoursCompact.vue?vue&type=template&id=04845d40&scoped=true"
import script from "./SalarieHoursCompact.vue?vue&type=script&lang=js"
export * from "./SalarieHoursCompact.vue?vue&type=script&lang=js"
import style0 from "./SalarieHoursCompact.vue?vue&type=style&index=0&id=04845d40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04845d40",
  null
  
)

export default component.exports